import { Avatar, Box, Card, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LocationIcon } from "./Utils/Common/Icons";
import { complexQuery } from "./Utils/Common/Library";
import { constants } from "./NComponent/pms/Dimension/Data/QueryConstants";

function UserCard({ role, UserID }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (UserID) {
      complexQuery({
        QueryName: constants.FindUserAndItsOrganisationDetails,
        RequiredFields: [{ UserID }],
      }).then((res) => {
        setData(res[0]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !data ? (
    <>Loading user ...</>
  ) : (
    <Card
      sx={{
        position: "relative",
        overflow: "visible",
        boxShadow: "0px 0px 3px #B1AEBB",
        borderRadius: "12px",
        paddingBottom: "0.5rem",
      }}
    >
      <Box
        position={"absolute"}
        sx={{ top: "-7px", backgroundColor: "white", display: "flex" }}
      >
        <Typography variant="masthead-menu" fontWeight={400} color={"primary"}>
          {role}
        </Typography>
      </Box>
      <Stack rowGap={"0.5rem"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Avatar
              src="https://www.pngarts.com/files/10/Default-Profile-Picture-Transparent-Image.png"
              sx={{ height: "2em", width: "2em" }}
            />
            <Typography variant="subtitle2">{data.FullName || ""}</Typography>
          </Box>
          <Typography variant="p5" fontWeight={400} color={"#6A6A6A"}>
            #{data.EmployeeCode || ""}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.3em",
            flex: 1,
          }}
        >
          <Typography variant="p5" color={"#6A6A6A"}>
            {data.RoleName || ""}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="p5" color={"#6A6A6A"}>
              {data.DesignationName || ""}
            </Typography>
            <Box display={"flex"} alignItems={"center"} gap={"0.3rem"}>
              <LocationIcon />
              <Typography variant="p5" fontWeight={400} color={"#6A6A6A"}>
                {data.LocationName || ""}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Stack>
    </Card>
  );
}

export default UserCard;
